export const GameConfig = {
	boardOffSetX: 50,
	boardOffSetY: 100,
	balaceStart: 1000,
	maxBet: 5000,
	blacks: [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35],
	reds: [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36],
	numbers: [
		0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26
	],
	area: [
		{
			name: 'b0',
			x: 600,
			y: 280,
			polygon: [
				{ x: 22, y: -123 }, // TOPO
				{ x: -25, y: -6 }, // MIDDLE
				{ x: 22, y: 105 }, // BOTTOM 2
				{ x: 40, y: 105 }, // BOTTOM 1
				{ x: 40, y: 0 }, // MIDDLE
				{ x: 40, y: -123 } // TOP
			]
		},
		{ name: 'b_0n1', x: 650, y: 353, width: 8.1, height: 65 },
		{ name: 'b_0n1n2', x: 650, y: 311, width: 7.9, height: 8.2 },
		{ name: 'b_0n2', x: 650, y: 270, width: 8.1, height: 62 },
		{ name: 'b_0n2n3', x: 650, y: 231, width: 7.9, height: 8.2 },
		{ name: 'b_0n3', x: 650, y: 191, width: 8.1, height: 62 },
		{ name: 'b_0n1n2n3', x: 650, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b1', x: 680, y: 353, width: 45, height: 65 },
		{ name: 'b_1n2', x: 680, y: 311, width: 45, height: 8.2 },
		{ name: 'b2', x: 680, y: 270, width: 45, height: 62 },
		{ name: 'b_2n3', x: 680, y: 231, width: 45, height: 8.2 },
		{ name: 'b3', x: 680, y: 191, width: 45, height: 62 },
		{ name: 'b_1n2n3', x: 680, y: 152, width: 45, height: 8.2 },

		{ name: 'b_1n4', x: 710, y: 353, width: 8.1, height: 65 },
		{ name: 'b_1n2n4n5', x: 710, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_2n5', x: 710, y: 270, width: 8.1, height: 62 },
		{ name: 'b_2n3n5n6', x: 710, y: 231, width: 7.9, height: 8.2 },
		{ name: 'b_3n6', x: 710, y: 191, width: 8.1, height: 62 },
		{ name: 'b_1to6', x: 710, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b4', x: 740, y: 353, width: 43, height: 65 },
		{ name: 'b_4n5', x: 740, y: 311, width: 45, height: 8.2 },
		{ name: 'b5', x: 740, y: 270, width: 45, height: 62 },
		{ name: 'b_5n6', x: 740, y: 231, width: 45, height: 8.2 },
		{ name: 'b6', x: 740, y: 191, width: 45, height: 62 },
		{ name: 'b_4n5n6', x: 740, y: 152, width: 45, height: 8.2 },

		{ name: 'b_4n7', x: 769, y: 353, width: 8.1, height: 65 },
		{ name: 'b_4n5n7n8', x: 769, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_5n8', x: 769, y: 270, width: 8.1, height: 62 },
		{ name: 'b_5n6n8n9', x: 769, y: 231, width: 7.9, height: 8.2 },
		{ name: 'b_6n9', x: 769, y: 191, width: 8.1, height: 62 },
		{ name: 'b_4to9', x: 769, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b7', x: 799, y: 353, width: 43, height: 65 },
		{ name: 'b_7n8', x: 799, y: 311, width: 45, height: 8.2 },
		{ name: 'b8', x: 799, y: 270, width: 45, height: 62 },
		{ name: 'b_8n9', x: 799, y: 231, width: 45, height: 8.2 },
		{ name: 'b9', x: 799, y: 191, width: 45, height: 62 },
		{ name: 'b_7n8n9', x: 799, y: 152, width: 45, height: 8.2 },

		{ name: 'b_7n10', x: 829, y: 353, width: 8.1, height: 65 },
		{ name: 'b_7n8n10n11', x: 829, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_8n11', x: 829, y: 270, width: 8.1, height: 62 },
		{ name: 'b_8n9n11n12', x: 829, y: 231, width: 7.9, height: 8.2 },
		{ name: 'b_9n12', x: 829, y: 191, width: 8.1, height: 62 },
		{ name: 'b_7to12', x: 829, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b10', x: 859, y: 353, width: 43, height: 65 },
		{ name: 'b_10n11', x: 859, y: 311, width: 45, height: 8.2 },
		{ name: 'b11', x: 859, y: 270, width: 45, height: 62 },
		{ name: 'b_11n12', x: 859, y: 231, width: 45, height: 8.2 },
		{ name: 'b12', x: 859, y: 191, width: 45, height: 62 },
		{ name: 'b_10n11n12', x: 859, y: 152, width: 45, height: 8.2 },

		{ name: 'b_10n13', x: 889, y: 353, width: 8.1, height: 65 },
		{ name: 'b_10n11n13n14', x: 889, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_11n14', x: 889, y: 270, width: 8.1, height: 62 },
		{ name: 'b_11n12n14n15', x: 889, y: 231, width: 7.9, height: 8.2 },
		{ name: 'b_12n15', x: 889, y: 191, width: 8.1, height: 62 },
		{ name: 'b_10to15', x: 889, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b13', x: 919, y: 353, width: 43, height: 65 },
		{ name: 'b_13n14', x: 919, y: 311, width: 45, height: 8.2 },
		{ name: 'b14', x: 919, y: 270, width: 45, height: 62 },
		{ name: 'b_14n15', x: 919, y: 231, width: 45, height: 8.2 },
		{ name: 'b15', x: 919, y: 191, width: 45, height: 62 },
		{ name: 'b_13n14n15', x: 919, y: 152, width: 45, height: 8.2 },

		{ name: 'b_13n16', x: 948, y: 353, width: 8.1, height: 65 },
		{ name: 'b_13n14n16n17', x: 948, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_14n17', x: 948, y: 270, width: 8.1, height: 62 },
		{ name: 'b_14n15n17n18', x: 948, y: 231, width: 7.9, height: 8.2 },
		{ name: 'b_15n18', x: 948, y: 191, width: 8.1, height: 62 },
		{ name: 'b_13to18', x: 948, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b16', x: 978, y: 353, width: 43, height: 65 },
		{ name: 'b_16n17', x: 978, y: 311, width: 45, height: 8.2 },
		{ name: 'b17', x: 978, y: 270, width: 45, height: 62 },
		{ name: 'b_17n18', x: 978, y: 231, width: 45, height: 8.2 },
		{ name: 'b18', x: 978, y: 191, width: 45, height: 62 },
		{ name: 'b_16n17n18', x: 978, y: 152, width: 45, height: 8.2 },

		{ name: 'b_16n19', x: 1008, y: 353, width: 8.1, height: 65 },
		{ name: 'b_16n17n19n20', x: 1008, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_17n20', x: 1008, y: 270, width: 8.1, height: 62 },
		{ name: 'b_17n18n20n21', x: 1008, y: 231, width: 8.2, height: 8.1 },
		{ name: 'b_18n21', x: 1008, y: 191, width: 8.1, height: 62 },
		{ name: 'b_16to21', x: 1008, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b19', x: 1038, y: 353, width: 43, height: 65 },
		{ name: 'b_19n20', x: 1038, y: 311, width: 45, height: 8.2 },
		{ name: 'b20', x: 1038, y: 270, width: 45, height: 62 },
		{ name: 'b_20n21', x: 1038, y: 231, width: 45, height: 8.2 },
		{ name: 'b21', x: 1038, y: 191, width: 45, height: 62 },
		{ name: 'b_19n20n21', x: 1038, y: 152, width: 45, height: 8.2 },

		{ name: 'b_19n22', x: 1068, y: 353, width: 8.1, height: 65 },
		{ name: 'b_19n20n22n23', x: 1068, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_20n23', x: 1068, y: 270, width: 8.1, height: 62 },
		{ name: 'b_20n21n23n24', x: 1068, y: 231, width: 8.2, height: 8.1 },
		{ name: 'b_21n24', x: 1068, y: 191, width: 8.1, height: 62 },
		{ name: 'b_19to24', x: 1068, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b22', x: 1098, y: 353, width: 43, height: 65 },
		{ name: 'b_22n23', x: 1098, y: 311, width: 45, height: 8.2 },
		{ name: 'b23', x: 1098, y: 270, width: 45, height: 62 },
		{ name: 'b_23n24', x: 1098, y: 231, width: 45, height: 8.2 },
		{ name: 'b24', x: 1098, y: 191, width: 45, height: 62 },
		{ name: 'b_22n23n24', x: 1098, y: 152, width: 45, height: 8.2 },

		{ name: 'b_22n25', x: 1128, y: 353, width: 8.1, height: 65 },
		{ name: 'b_22n23n25n26', x: 1128, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_23n26', x: 1128, y: 270, width: 8.1, height: 62 },
		{ name: 'b_23n24n26n27', x: 1128, y: 231, width: 8.2, height: 8.1 },
		{ name: 'b_24n27', x: 1128, y: 191, width: 8.1, height: 62 },
		{ name: 'b_22to27', x: 1128, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b25', x: 1158, y: 353, width: 43, height: 65 },
		{ name: 'b_25n26', x: 1158, y: 311, width: 45, height: 8.2 },
		{ name: 'b26', x: 1158, y: 270, width: 45, height: 62 },
		{ name: 'b_26n27', x: 1158, y: 231, width: 45, height: 8.2 },
		{ name: 'b27', x: 1158, y: 191, width: 45, height: 62 },
		{ name: 'b_25n26n27', x: 1158, y: 152, width: 45, height: 8.2 },

		{ name: 'b_25n28', x: 1188, y: 353, width: 8.1, height: 65 },
		{ name: 'b_25n26n28n29', x: 1188, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_26n29', x: 1188, y: 270, width: 8.1, height: 62 },
		{ name: 'b_26n27n29n30', x: 1188, y: 231, width: 8.2, height: 8.1 },
		{ name: 'b_27n30', x: 1188, y: 191, width: 8.1, height: 62 },
		{ name: 'b_25to30', x: 1188, y: 152, width: 8.2, height: 8.1 },

		{ name: 'b28', x: 1218, y: 353, width: 43, height: 65 },
		{ name: 'b_28n29', x: 1218, y: 311, width: 45, height: 8.2 },
		{ name: 'b29', x: 1218, y: 270, width: 45, height: 62 },
		{ name: 'b_29n30', x: 1218, y: 231, width: 45, height: 8.2 },
		{ name: 'b30', x: 1218, y: 191, width: 45, height: 62 },
		{ name: 'b_28n29n30', x: 1218, y: 152, width: 45, height: 8.2 },

		{ name: 'b_28n31', x: 1247, y: 353, width: 8.1, height: 65 },
		{ name: 'b_28n29n31n32', x: 1247, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_29n32', x: 1247, y: 270, width: 8.1, height: 62 },
		{ name: 'b_29n30n32n33', x: 1247, y: 231, width: 8.1, height: 8.2 },
		{ name: 'b_30n33', x: 1247, y: 191, width: 8.1, height: 62 },
		{ name: 'b_28to33', x: 1247, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b31', x: 1277, y: 353, width: 43, height: 65 },
		{ name: 'b_31n32', x: 1277, y: 311, width: 45, height: 8.2 },
		{ name: 'b32', x: 1277, y: 270, width: 45, height: 62 },
		{ name: 'b_32n33', x: 1277, y: 231, width: 45, height: 8.2 },
		{ name: 'b33', x: 1277, y: 191, width: 45, height: 62 },
		{ name: 'b_31n32n33', x: 1277, y: 152, width: 45, height: 8.2 },

		{ name: 'b_31n34', x: 1307, y: 353, width: 8.1, height: 65 },
		{ name: 'b_31n32n34n35', x: 1307, y: 311, width: 8.1, height: 8.2 },
		{ name: 'b_32n35', x: 1307, y: 270, width: 8.1, height: 62 },
		{ name: 'b_32n33n35n36', x: 1307, y: 231, width: 8.1, height: 8.2 },
		{ name: 'b_33n36', x: 1307, y: 191, width: 8.1, height: 62 },
		{ name: 'b_31to36', x: 1307, y: 152, width: 8.1, height: 8.2 },

		{ name: 'b34', x: 1338, y: 353, width: 48, height: 65 },
		{ name: 'b_34n35', x: 1338, y: 311, width: 48, height: 8.2 },
		{ name: 'b35', x: 1338, y: 270, width: 48, height: 62 },
		{ name: 'b_35n36', x: 1338, y: 231, width: 48, height: 8.2 },
		{ name: 'b36', x: 1338, y: 191, width: 48, height: 62 },
		{ name: 'b_34n35n36', x: 1338, y: 152, width: 48, height: 8.2 },

		{ name: 'b_1_12', x: 769, y: 430, width: 228, height: 68 },
		{ name: 'b_2_12', x: 1008, y: 430, width: 228, height: 68 },
		{ name: 'b_3_12', x: 1247, y: 430, width: 228, height: 68 },
		{ name: 'b_1_18', x: 709, y: 520, width: 107, height: 90 },
		{ name: 'b_2_18', x: 1307, y: 520, width: 107, height: 90 },
		{ name: 'b_even', x: 829, y: 520, width: 107, height: 90 },
		{ name: 'b_odd', x: 1187, y: 520, width: 107, height: 90 },
		{ name: 'b_red', x: 948, y: 520, width: 107, height: 90 },
		{ name: 'b_dark', x: 1068, y: 520, width: 107, height: 90 },

		{ name: 'b_2_1_1', x: 1396, y: 351, width: 52, height: 72 },
		{ name: 'b_2_1_2', x: 1396, y: 270, width: 52, height: 72 },
		{ name: 'b_2_1_3', x: 1396, y: 191, width: 52, height: 72 }

		//{ name: 'bser58', x: 366, y: 425, width: 70, height: 40 },
		//{ name: 'bgser', x: 445, y: 425, width: 70, height: 40 },
		//{ name: 'borpl', x: 522, y: 425, width: 70, height: 40 },
		//{ name: 'borch', x: 600, y: 425, width: 70, height: 40 }
		//{ name: 'bzerogame', x: 675, y: 425, width: 70, height: 40 }
	],
	areaHighlight: [
		{ name: 'highlight1', x: 518, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight2', x: 518, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight3', x: 518, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight4', x: 577, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight5', x: 577, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight6', x: 577, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight7', x: 637, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight8', x: 637, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight9', x: 637, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight10', x: 696, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight11', x: 696, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight12', x: 696, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight13', x: 756, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight14', x: 756, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight15', x: 756, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight16', x: 816, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight17', x: 816, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight18', x: 816, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight19', x: 876, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight20', x: 876, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight21', x: 876, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight22', x: 935, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight23', x: 935, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight24', x: 935, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight25', x: 995, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight26', x: 995, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight27', x: 995, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight28', x: 1055, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight29', x: 1055, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight30', x: 1055, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight31', x: 1114, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight32', x: 1114, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight33', x: 1114, y: 22, width: 56, height: 75 }, // OK

		{ name: 'highlight34', x: 1174, y: 182, width: 56, height: 75 }, // OK
		{ name: 'highlight35', x: 1174, y: 102, width: 56, height: 75 }, // OK
		{ name: 'highlight36', x: 1174, y: 22, width: 56, height: 75 }, // OK
		{
			name: 'highlight0',
			x: 600,
			y: 280,
			width: 166,
			height: 24,
			polygon: [
				{ x: 18, y: -128 }, // TOPO
				{ x: -33, y: -8 }, // MIDDLE
				{ x: 16, y: 110 }, // BOTTOM 2
				{ x: 48, y: 110 }, // BOTTOM 1
				{ x: 48, y: 10 }, // MIDDLE
				{ x: 48, y: -128 } // TOP
			]
		}
	],
	numang: [
		{ n: 0, a: 0 },
		{ n: 1, a: 2.38 },
		{ n: 2, a: 5.27 },
		{ n: 3, a: 0.34 },
		{ n: 4, a: 5.61 },
		{ n: 5, a: 3.06 },
		{ n: 6, a: 4.59 },
		{ n: 7, a: 1.02 },
		{ n: 8, a: 3.57 },
		{ n: 9, a: 1.7 },
		{ n: 10, a: 3.23 },
		{ n: 11, a: 3.91 },
		{ n: 12, a: 0.68 },
		{ n: 13, a: 4.25 },
		{ n: 14, a: 2.04 },
		{ n: 15, a: 5.95 },
		{ n: 16, a: 2.72 },
		{ n: 17, a: 4.93 },
		{ n: 18, a: 1.36 },
		{ n: 19, a: 5.78 },
		{ n: 20, a: 2.21 },
		{ n: 21, a: 5.44 },
		{ n: 22, a: 1.53 },
		{ n: 23, a: 3.4 },
		{ n: 24, a: 2.89 },
		{ n: 25, a: 5.1 },
		{ n: 26, a: 0.17 },
		{ n: 27, a: 4.42 },
		{ n: 28, a: 0.85 },
		{ n: 29, a: 1.19 },
		{ n: 30, a: 3.74 },
		{ n: 31, a: 1.87 },
		{ n: 32, a: 6.12 },
		{ n: 33, a: 2.55 },
		{ n: 34, a: 4.76 },
		{ n: 35, a: 0.51 },
		{ n: 36, a: 4.08 }
	],
	fonts: [{ fontName: 'gameFont_0', filePNG: 'fonts/RousseauDeco_42_0.png', fileXML: 'fonts/RousseauDeco_42_0.xml' }],
	sprites: [
		{ fileName: null, name: 'debugreference' },
		{ fileName: 'chip-orange.png', name: 'chip-orange' },
		{ fileName: 'chip-blue.png', name: 'chip-blue' },
		{ fileName: 'chip-gray.png', name: 'chip-gray' },
		{ fileName: 'chip-black.png', name: 'chip-black' },
		{ fileName: 'chip-green.png', name: 'chip-green' },
		{ fileName: 'chip-pink.png', name: 'chip-pink' },
		{ fileName: 'chip-purple.png', name: 'chip-purple' },
		{ fileName: 'chip-yellow.png', name: 'chip-yellow' },
		{ fileName: 'table-new.png', name: 'rouletteTable' },
		{ fileName: 'roulette.png', name: 'roulette' },
		{ fileName: 'board-sticks.png', name: 'boardSticks' },
		{ fileName: 'board-center.png', name: 'boardCenter' },
		{ fileName: 'nyxlogo.png', name: 'nyxLogo' },
		{ fileName: 'white-background.png', name: 'white-background' },
		{ fileName: 'background.png', name: 'background' },
		{ fileName: 'history_bucket.png', name: 'bucket' },
		{ fileName: 'history_bucket_shadown.png', name: 'bucketShadown' },
		{ fileName: 'green_ball.png', name: 'greenBall' },
		{ fileName: 'red_ball.png', name: 'redBall' },
		{ fileName: 'black_ball.png', name: 'blackBall' },
		// Buttons
		{ fileName: 'button-menu.png', name: 'button-menu' },
		{ fileName: 'button-menu-hover.png', name: 'button-menu-hover' },
		{ fileName: 'button-info.png', name: 'button-info' },
		{ fileName: 'button-info-hover.png', name: 'button-info-hover' },
		{ fileName: 'button-spin.png', name: 'button-spin' },
		{ fileName: 'button-spin-hover.png', name: 'button-spin-hover' },
		{ fileName: 'button-undo.png', name: 'button-undo' },
		{ fileName: 'button-undo-hover.png', name: 'button-undo-hover' },
		{ fileName: 'button-delete.png', name: 'button-delete' },
		{ fileName: 'button-delete-hover.png', name: 'button-delete-hover' },
		{ fileName: 'button-facebook.png', name: 'button-facebook' },
		{ fileName: 'button-twitter.png', name: 'button-twitter' },
		{ fileName: 'button-whatsapp.png', name: 'button-whatsapp' },
		// Panels
		{ fileName: 'info-panel.png', name: 'info-panel' },
		{ fileName: 'navi-marker.png', name: 'navi-marker' },
		{ fileName: 'navi-marker-active.png', name: 'navi-marker-active' },
		{ fileName: 'navi-dot.png', name: 'navi-dot' },
		{ fileName: 'exit-button.png', name: 'exit-button' },
		{ fileName: 'exit-button-hover.png', name: 'exit-button-hover' },
		{ fileName: 'next-button.png', name: 'next-button' },
		{ fileName: 'next-button-hover.png', name: 'next-button-hover' },
		{ fileName: 'prev-button.png', name: 'prev-button' },
		{ fileName: 'prev-button-hover.png', name: 'prev-button-hover' }
	]
};
